// import MovieService from "@/services/MovieService";
// import { LanguageService } from "@/services/tokenService";
import MainServices from "@/services/mainService.js";
import GlobalServices from "@/services/GlobalServices.js";
import Vue from "vue";
import { groupBy } from "lodash";
import moment from "moment";
import store from "@/store";

const state = {
  currentRoute: null,
  nowShowingMovies: [],
  nowShowingCinemas: [],
  nowShowingSchedules: [],
  nowShowingDates: [],
  nowShowingMoviesType: [],
  fileredMovies: null,
  movieGenre: [],
  moviedetails: [],
  Banners: [],
  languages: [],
  allLanguages: [],
  formats: [],
  allFormats: [],
  genres: [],
  allGenres: [],
  selectedDate: null,
  selectedLanguage: null,
  selectedGenre: null,
  selectedFormat: null,
  selectedCinema: null,
  quickBookMovies: [],
  filteredQuickBookMovies: [],
  quickBookCinemas: [],
  quickBookDates: [],
  quickBookTimes: [],
  filteredQuickBookCinemas: [],
  selectedQBMovie: null,
  selectedQBCinema: null,
  selectedQBDate: null,
  selectedQBTime: null,
  user_reviews: [],
  stripePublisherKey: null,
  areLanguagesFiltered: false,
  areGenresFiltered: false,
  areFormatsFiltered: false,
  CinemasList: [],
  global_options: [],
  curr_code: "",
  countries: []
};

const mutations = {
  SET_LANGUAGES: (state, payload) => (state.languages = payload),
  SET_ALL_LANGUAGES: (state, payload) => (state.allLanguages = payload),
  SET_FORMATS: (state, payload) => (state.formats = payload),
  SET_ALL_FORMATS: (state, payload) => (state.allFormats = payload),
  SET_GENRES: (state, payload) => (state.genres = payload),
  SET_ALL_GENRES: (state, payload) => (state.allGenres = payload),
  RESET_FILTERS: state => (state.fileredMovies = state.nowShowingMoviesType),
  SET_FILTERED_MOVIES: (state, payload) => (state.fileredMovies = payload),
  SET_SELECTED_CINEMA: (state, payload) => (state.selectedCinema = payload),
  SET_ARE_GENRES_FILTERED: (state, payload) =>
    (state.areGenresFiltered = payload),
  SET_ARE_LANGUAGES_FILTERED: (state, payload) =>
    (state.areLanguagesFiltered = payload),
  SET_ARE_FORMATS_FILTERED: (state, payload) =>
    (state.areFormatsFiltered = payload),
  RESET_FILTERED_FLAGS: state => {
    state.areGenresFiltered = false;
    state.areLanguagesFiltered = false;
    state.areFormatsFiltered = false;
  },
  RESET_FILTERS: state => {
    state.selectedFormat = null;
    state.selectedGenre = null;
    state.selectedLanguage = null;
    state.selectedCinema = null;
  },
  SET_CURRENT_ROUTE: (state, payload) => {
    state.currentRoute = payload;
  },
  SET_NOWSHOWING_MOVIES: (state, payload) => {
    state.nowShowingMovies = payload.MovieListResult;
  },
  SET_NOWSHOWING_MOVIE_TYPE: (state, payload) => {
    state.nowShowingMoviesType = payload;
  },
  SET_NOWSHOWING_CINEMAS: (state, payload) => {
    state.nowShowingCinemas = payload;
  },
  SET_NOWSHOWING_SCHEDULES: (state, payload) => {
    state.nowShowingSchedules.push(payload);
  },
  SET_NOWSHOWING_DATES: (state, payload) => {
    state.nowShowingDates = payload;
  },
  SET_NOWSHOWING_GENRE: (state, payload) => {
    state.moviedetails.push({
      ...payload.movieType,
      g_name: payload.genre.map(({ g_name }) => g_name).join(", ")
    });

    console.log(" state.moviedetails :", state.moviedetails);
    // let genredetails = payload.genre;

    // moviedetails = moviedetails.map((x, xindex) => {
    //     genredetails.map((y, yindex) => {
    //         if (xindex == yindex) {
    //             y.map(z => {
    //                 x['push'] = z.g_name;
    //             })
    //         }
    //     })
    //     return x;
    // });
    // console.log('moviedetails :', moviedetails);
    console.log("payload.movieType :", payload.movieType);
    console.log("payload.genre :", payload.genre);

    //moviedetails.push(payload.movieType.push(payload.genre.map(x => { ['genre'].push(x.g_name) })))
    // console.log('moviedetails :', payload.genre.map(x => { return x.g_name }));
    // console.log('payload.genre :', payload.genre);

    // state.genre.push(payload.genre.map(x => { return x.g_name }))
    // console.log('state.genre :', state.genre);
  },
  RESET_GENRE: state => {
    state.moviedetails = [];
  },
  SET_BANNERS_DATA: (state, payload) => {
    state.Banners = payload;
  },
  SET_SELECTED_DATE: (state, payload) => (state.selectedDate = payload),
  SET_SELECTED_LANGUAGE: (state, payload) => (state.selectedLanguage = payload),
  SET_SELECTED_GENRE: (state, payload) => (state.selectedGenre = payload),
  SET_SELECTED_FORMAT: (state, payload) => (state.selectedFormat = payload),
  SET_QUICK_BOOK_MOVIES: (state, payload) => (state.quickBookMovies = payload),
  SET_FILTERED_QUICK_BOOK_MOVIES: (state, payload) =>
    (state.filteredQuickBookMovies = payload),
  SET_QUICK_BOOK_CINEMAS: (state, payload) =>
    (state.quickBookCinemas = payload),
  SET_QUICK_BOOK_DATES: (state, payload) => (state.quickBookDates = payload),
  SET_QUICK_BOOK_TIMES: (state, payload) => (state.quickBookTimes = payload),
  SET_FILTERED_QUICK_BOOK_CINEMAS: (state, payload) =>
    (state.filteredQuickBookCinemas = payload),
  FILTER_QUICK_BOOK_DATA: (state, payload) => {
    const { type, value } = payload;
    console.log("payload", payload);

    switch (type) {
      case "movie":
        state.filteredQuickBookMovies = state.quickBookMovies.filter(item =>
          item.movie_title.toLowerCase().includes(value.toLowerCase())
        );
      case "cinema":
        state.filteredQuickBookCinemas = state.quickBookCinemas.filter(item =>
          item.cine_name.toLowerCase().includes(value.toLowerCase())
        );
        break;
    }
  },
  SET_SELECTED_QB_MOVIE: (state, payload) => (state.selectedQBMovie = payload),
  SET_SELECTED_QB_CINEMA: (state, payload) =>
    (state.selectedQBCinema = payload),
  SET_SELECTED_QB_DATE: (state, payload) => (state.selectedQBDate = payload),
  SET_SELECTED_QB_TIME: (state, payload) => (state.selectedQBTime = payload),
  SET_GLOBAL_OPTIONS: (state, payload) => (state.global_options = payload),
  SET_COUNTRIES: (state, payload) => (state.countries = payload),
  SET_CURR_CODE: (state, payload) => (state.curr_code = payload),
  SET_USER_REVIEWS: (state, payload) => (state.user_reviews = payload),
  CLEAR_QB_DATA: state => {
    state.selectedQBMovie = null;
    state.selectedQBCinema = null;
    state.selectedQBDate = null;
    state.selectedQBTime = null;
  },
  SET_CINEMAS_LIST: (state, payload) => (state.CinemasList = payload),
  SET_STRIPE_PUBLISHER_KEY: (state, payload) =>
    (state.stripePublisherKey = payload)
};

const actions = {
  fetchGlobalOptions: async ({ commit }, payload) => {
    console.log("inside fetch global options");
    GlobalServices.GetGlobalOptions().then(async response => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        commit("SET_GLOBAL_OPTIONS", data.Records);
        const currency = data.Records.find(go => go.go_key === "CURRENCY");
        const { data: currencyData } = await GlobalServices.GetCurrency({
          curr_id: currency.go_value
        });
        console.log("SET_CURR_CODE", currencyData);
        if (currencyData && currencyData.status && currencyData.Records) {
          if (currencyData.Records.curr_code == "USD") {
            currencyData.Records.curr_code = "$";
          }
          commit("SET_CURR_CODE", currencyData.Records.curr_code);
        }
      } else {
        console.log("Erro in fetching global options");
      }
    });
  },
  fetchCountries: async ({ commit }, payload) => {
    MainServices.GetCountries()
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          commit("SET_COUNTRIES", data.Records);
        } else {
          console.log("Error", data.message);
        }
      })
      .catch(err => {
        console.log("Error", err);
      });
  },
  setCurrentRoute({ commit }, payload) {
    commit("SET_CURRENT_ROUTE", payload);
  },
  // fetchAllCinemas: function({ commit }) {
  //   let payload = {
  //     Flag: "Popular",
  //     latitude: null,
  //     longitude: null,
  //     location: false
  //   };

  //   return MovieService.GetCinemas(payload)
  //     .then(response => {
  //       const { data } = response;
  //       if (data && data.status && data.Records.length > 0) {
  //         commit("SET_CINEMAS_LIST", data.Records);
  //       } else {
  //         this.$toasted.show(data.message);
  //       }
  //     })
  //     .catch(error => {
  //       this.$toasted.show(Error(error));
  //     });
  // },
  // setNowShowingMovies({ commit }, payload) {
  //     commit('SET_NOWSHOWING_MOVIES', payload)
  // },
  getAllMovies({ state, dispatch, commit }, payload) {
    const { date } = payload;
    let movieFlag = payload.flag ? payload.flag : null;
    commit("RESET_FILTERED_FLAGS");
    commit("SET_FILTERED_MOVIES", null);
    let savedLang = LanguageService.getLanguage();
    let content_lang;
    if (savedLang && savedLang.lang_id) {
      content_lang = savedLang.lang_id;
    }
    let loader = Vue.$loading.show();
    return MovieService.GetMovies({
      limit: 8,
      date,
      content_lang,
      flag: movieFlag
    })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          console.log("mydata :", data);
          // commit('SET_NOWSHOWING_MOVIES', data)
          commit("SET_NOWSHOWING_MOVIE_TYPE", data.Records);
          commit("SET_FILTERED_MOVIES", data.Records);
          commit("SET_CINEMAS_LIST", data.cinemasList);
          commit("RESET_FILTERS");

          filterGenres(state, dispatch, commit);
          filterLanguages(state, dispatch, commit);
          filterFormats(state, dispatch, commit);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      })
      .finally(() => {
        loader.hide();
      });
  },
  getAllMovieTypeDetails: async ({ commit, dispatch }) => {
    MovieService.GetMovieTypeDetails()
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          console.log("mydatatype :", data.Records);

          // commit('SET_NOWSHOWING_MOVIE_TYPE', data.Records)
          commit("RESET_GENRE");
          // dispatch('getGenre', data.Records)
        } else {
          // Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },

  // getGenre: async ({ commit }, payload) => {
  //     let finalArray = []
  //     for (let i in payload) {
  //         MovieService.GetGenre({ movie_id: payload[i].movie_id })
  //             .then(async response => {
  //                 const { data } = response;
  //                 if (data && data.status) {
  //                     // console.log('mydatagenre :', data.Records);
  //                     await commit('SET_NOWSHOWING_GENRE', { genre: data.Records, movieType: payload[i] })
  //                 }

  //                 else {
  //                     Vue.toasted.show(data.message);
  //                 }
  //             })
  //             .catch(error => {
  //                 Vue.toasted.show(error);
  //             });
  //     }
  // },

  getAllCinemas({ commit }) {
    return MovieService.GetCinemas({ location: false })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          console.log("mydatacinemas :", data);
          commit("SET_NOWSHOWING_CINEMAS", data);
        } else {
          // Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },

  getAllShowDates({ commit }) {
    return MovieService.GetAllShowDates()
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          // console.log('mydatadates :', data.Records);
          commit("SET_NOWSHOWING_DATES", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  getActiveBanners({ commit }) {
    let savedLang = LanguageService.getLanguage();
    let content_lang;
    if (savedLang && savedLang.lang_id) {
      content_lang = savedLang.lang_id;
    }
    return MovieService.GetActiveBanners({ lang_id: content_lang })
      .then(response => {
        const { data } = response;

        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            const uniqueMovies = [
              ...new Map(
                data.Records.map(item => [item["movie_id"], item])
              ).values()
            ];
            commit("SET_BANNERS_DATA", uniqueMovies);
          }
        } else {
          // Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  onSelectLanguage({ commit, state, dispatch }, payload) {
    console.log("onSelectLanguage called");
    if (
      state.selectedLanguage &&
      state.selectedLanguage.lang_id === payload.lang_id
    ) {
      dispatch("clearFilter", { type: "language" });
      return;
    }

    commit("SET_SELECTED_LANGUAGE", payload);
    dispatch("filterMovies");
  },
  onSelectCinemaFilter({ commit, state, dispatch }, payload) {
    console.log("onSelectCinemaFilter called");
    if (
      state.selectedCinema &&
      state.selectedCinema.cine_id === payload.cine_id
    ) {
      dispatch("clearFilter", { type: "cinema" });
      return;
    }

    commit("SET_SELECTED_CINEMA", payload);
    dispatch("filterMovies");
  },
  onSelectGenre({ commit, state, dispatch }, payload) {
    console.log("onSelectGenre called with payload: ", payload);
    if (state.selectedGenre && state.selectedGenre.g_id === payload.g_id) {
      dispatch("clearFilter", { type: "genre" });
      return;
    }

    commit("SET_SELECTED_GENRE", payload);
    dispatch("filterMovies");
  },
  onSelectFormat({ commit, state, dispatch }, payload) {
    if (state.selectedFormat && state.selectedFormat === payload.mf_name) {
      dispatch("clearFilter", { type: "format" });
      return;
    }

    commit("SET_SELECTED_FORMAT", payload.mf_name);
    dispatch("filterMovies");
  },
  onSelectDate({ commit, state, dispatch }, payload) {
    console.log("payload", payload);
    if (state.selectedDate && state.selectedDate === payload) {
      dispatch("clearFilter", { type: "date" });
      return;
    }

    commit("SET_SELECTED_DATE", payload);
    dispatch("getAllMovies", { date: payload });
  },
  filterMovies({ commit, state, dispatch }, payload) {
    let selectedGenre = state.selectedGenre;
    let selectedLanguage = state.selectedLanguage;
    let selectedFormat = state.selectedFormat;
    let selectedCinema = state.selectedCinema;

    let movies = state.nowShowingMoviesType;

    if (selectedGenre) {
      movies = movies.filter(movie =>
        movie.genres && movie.genres.length > 0
          ? movie.genres.some(g => g.genre_id === selectedGenre.genre_id)
          : false
      );
    }

    if (selectedLanguage) {
      movies = movies.filter(movie =>
        movie.languages && movie.languages.length > 0
          ? movie.languages.some(
              l => l.language_id === selectedLanguage.language_id
            )
          : false
      );
    }

    if (selectedFormat) {
      movies = movies.filter(movies => movies.mf_name === selectedFormat);
    }

    if (selectedCinema) {
      movies = movies.filter(
        movie =>
          movie.available_in_cinemas &&
          movie.available_in_cinemas.includes(selectedCinema.cine_id)
      );
    }

    commit("SET_FILTERED_MOVIES", movies);
  },
  clearFilter({ commit, state, dispatch }, payload) {
    console.log("clearFilter payload", payload);
    const { type } = payload;
    switch (type) {
      case "date":
        commit("SET_SELECTED_DATE", null);
        dispatch("getAllMovies", { date: null });
        break;
      case "language":
        commit("SET_SELECTED_LANGUAGE", null);
        break;
      case "genre":
        commit("SET_SELECTED_GENRE", null);
        break;
      case "format":
        commit("SET_SELECTED_FORMAT", null);
        break;
      case "cinema":
        commit("SET_SELECTED_CINEMA", null);
        break;
    }
    dispatch("filterMovies");
    // dispatch("getAllMovies", { date: null });
  },
  async fetchLanguages({ commit, state, dispatch }) {
    try {
      const { data } = await MovieService.GetLanguages();
      if (data && data.status && data.languages.length > 0) {
        commit("SET_LANGUAGES", data.languages);
        commit("SET_ALL_LANGUAGES", data.languages);
        filterLanguages(state, dispatch, commit);
      } else {
        throw new Error("Error while fetching languages.");
      }
    } catch (error) {
      console.error(error);
    }
  },
  async fetchFormats({ commit, state, dispatch }) {
    try {
      const { data } = await MovieService.GetFormats();
      if (data && data.status && data.formats.length > 0) {
        commit("SET_FORMATS", data.formats);
        commit("SET_ALL_FORMATS", data.formats);
        filterFormats(state, dispatch, commit);
      } else {
        throw new Error("Error while fetching formats.");
      }
    } catch (error) {
      console.error(error);
    }
  },
  async fetchGenres({ commit, state, dispatch }) {
    try {
      const { data } = await MovieService.GetGenres();
      console.log("data", data);
      if (data && data.status && data.genres.length > 0) {
        commit("SET_GENRES", data.genres);
        commit("SET_ALL_GENRES", data.genres);
        filterGenres(state, dispatch, commit);
      } else {
        throw new Error("Error while fetching genres.");
      }
    } catch (error) {
      console.error(error);
    }
  },
  async QuickBook({ commit, dispatch, state }, payload) {
    try {
      const { data } = await MovieService.QuickBook(payload);
      if (data && data.status) {
        commit("SET_QUICK_BOOK_MOVIES", data.movies);
        commit("SET_FILTERED_QUICK_BOOK_MOVIES", data.movies);
        if (data.cinemas) {
          commit("SET_QUICK_BOOK_CINEMAS", data.cinemas);
          commit("SET_FILTERED_QUICK_BOOK_CINEMAS", data.cinemas);
        }
        if (data.dates) {
          commit("SET_QUICK_BOOK_DATES", data.dates);
        }
        if (data.times) {
          commit("SET_QUICK_BOOK_TIMES", data.times);
        }
      }
    } catch (error) {
      console.error(error);
    }
  },
  onSearchQuickBook({ commit, dispatch, state }, payload) {
    commit("FILTER_QUICK_BOOK_DATA", payload);
  },
  onSelectMovie({ commit, dispatch, state }, payload) {
    dispatch("QuickBook", { movie_id: payload.movie_id });
    commit("CLEAR_QB_DATA");
    commit("SET_SELECTED_QB_MOVIE", payload);
  },
  onSelectCinema({ commit, dispatch, state }, payload) {
    dispatch("QuickBook", {
      cinema_id: payload.cine_id,
      movie_id: state.selectedQBMovie.movie_id
    });
    state.selectedQBDate = null;
    state.selectedQBTime = null;
    commit("SET_SELECTED_QB_CINEMA", payload);
  },
  onSelectQBDate({ commit, dispatch, state }, payload) {
    dispatch("QuickBook", {
      date: moment(payload.ss_start_date).format("DD-MM-YYYY"),
      cinema_id: payload.cine_id,
      movie_id: state.selectedQBMovie.movie_id
    });
    state.selectedQBTime = null;
    commit("SET_SELECTED_QB_DATE", payload);
  },
  onSelectTime({ commit, dispatch, state }, payload) {
    commit("SET_SELECTED_QB_TIME", payload);
  },
  onClickResetFilters({ commit, dispatch, state }, payload) {
    commit("RESET_FILTERS");
  },
  async addReview({ commit, dispatch, state }, payload) {
    try {
      const {
        stars,
        review_title,
        review_description,
        movie_id,
        cust_id
      } = payload;
      const { data } = await MovieService.AddReview({
        stars,
        review_title,
        review_description,
        movie_id,
        cust_id
      });
      if (data && data.status) {
        Vue.toasted.show(data.message);
        dispatch("fetchUserReviews", { movie_id });
      } else {
        Vue.toasted.show(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async fetchUserReviews({ commit, dispatch, state }, payload) {
    try {
      commit("SET_USER_REVIEWS", []);
      const { movie_id } = payload;
      const { data } = await MovieService.GetMovieReviews({
        movie_id
      });
      if (data && data.status) {
        commit("SET_USER_REVIEWS", data.reviews);
      } else {
        Vue.toasted.show(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async likeMovie({ commit, dispatch }, { movie_id, cust_id }) {
    try {
      const { data } = await MovieService.LikeMovie({ movie_id, cust_id });
      if (data && data.status && data.action) {
        Vue.toasted.show(`${data.action} successful`);
        data.action == "Like"
          ? commit("SET_TEMP_LIKE")
          : commit("RESET_TEMP_LIKE");
      } else {
        Vue.toasted.show(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async likeCinema({ commit, dispatch }, { cinema_id, cust_id, callback }) {
    try {
      const { data } = await MovieService.LikeCinema({ cinema_id, cust_id });
      if (data && data.status && data.action) {
        Vue.toasted.show(`${data.action} successful`);
        callback(data.action === "Like" ? true : false);
        data.action == "Like"
          ? commit("SET_TEMP_LIKE")
          : commit("RESET_TEMP_LIKE");
      } else {
        Vue.toasted.show(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
  onClickBookNowQB({ commit, dispatch }, payload) {
    commit("CLEAR_QB_DATA");
  },
  async fetchStripePublisherKey({ commit }, payload) {
    try {
      const { data } = await MovieService.GetStripePublisherKey();
      if (data && data.status) {
        commit("SET_STRIPE_PUBLISHER_KEY", data.stripePublisherKey);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async onSuccessStripeToken({ commit, dispatch }, payload) {
    try {
      let loader = Vue.$loading.show();
      const { email, country_mob_code, cust_mobile } = payload;
      const { reservationId, token } = payload;
      const { data } = await MovieService.CreateStripePaymentIntent({
        reservation_id: reservationId,
        token,
        cust_id:
          store.getters.login_details.length > 0
            ? store.getters.login_details[0].cust_id
            : null
      });
      if (data && data.status) {
        loader.hide();
        dispatch("bookSeats", { email, country_mob_code, cust_mobile });
      }
    } catch (error) {
      console.error(error);
    }
  }
};

function filterGenres(state, dispatch, commit) {
  if (
    state.allGenres &&
    state.allGenres.length > 0 &&
    state.fileredMovies &&
    Array.isArray(state.fileredMovies) &&
    !state.areGenresFiltered
  ) {
    commit("SET_ARE_GENRES_FILTERED", true);

    let filteredGenres = [];
    let genreIds = {};
    state.fileredMovies.forEach(m => {
      if (m.genres && Array.isArray(m.genres)) {
        m.genres.forEach(mg => {
          state.allGenres.forEach(g => {
            if (mg.genre_id === g.g_id && !genreIds[g.g_id]) {
              filteredGenres.push(g);
              genreIds[g.g_id] = true;
            }
          });
        });
      }
    });

    commit("SET_GENRES", filteredGenres);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_GENRES", []);
  }
}

function filterLanguages(state, dispatch, commit) {
  if (
    state.allLanguages &&
    state.allLanguages.length > 0 &&
    state.fileredMovies &&
    Array.isArray(state.fileredMovies) &&
    !state.areLanguagesFiltered
  ) {
    commit("SET_ARE_LANGUAGES_FILTERED", true);

    let filteredLanguages = [];
    let langIds = {};
    state.fileredMovies.forEach(m => {
      if (m.languages && Array.isArray(m.languages)) {
        m.languages.forEach(ml => {
          state.allLanguages.forEach(l => {
            if (ml.language_id === l.lang_id && !langIds[l.lang_id]) {
              filteredLanguages.push(l);
              langIds[l.lang_id] = true;
            }
          });
        });
      }
    });

    commit("SET_LANGUAGES", filteredLanguages);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_LANGUAGES", []);
  }
}

function filterFormats(state, dispatch, commit) {
  if (
    state.allFormats &&
    state.allFormats.length > 0 &&
    state.fileredMovies &&
    Array.isArray(state.fileredMovies) &&
    !state.areFormatsFiltered
  ) {
    commit("SET_ARE_FORMATS_FILTERED", true);

    let filteredFormats = [];
    let formatIds = {};
    state.fileredMovies.forEach(m => {
      state.allFormats.forEach(f => {
        if (m.mf_id === f.mf_id && !formatIds[f.mf_id]) {
          filteredFormats.push(f);
          formatIds[f.mf_id] = true;
        }
      });
    });

    commit("SET_FORMATS", filteredFormats);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_FORMATS", []);
  }
}

const getters = {
  getCurrentRoute: state => state.currentRoute,
  getNowShowingMovies: state => state.nowShowingMovies,
  getNowShowingCinemas: state => state.nowShowingCinemas,
  getNowShowingDates: state => state.nowShowingDates,
  getnowShowingMoviesType: state => state.nowShowingMoviesType,
  getFilteredMovies: state => state.fileredMovies,
  getnowGenre: state => state.genre,
  getallMovieDetails: state => state.moviedetails,
  getBanners: state => state.Banners,
  getLanguages: state => state.languages,
  getFormats: state => state.formats,
  getGenres: state => state.genres,
  getSelectedDate: state => state.selectedDate,
  getSelectedLanguage: state => state.selectedLanguage,
  getSelectedGenre: state => state.selectedGenre,
  getSelectedFormat: state => state.selectedFormat,
  getQuickBookMovies: state => state.quickBookMovies,
  getFilteredQuickBookMovies: state => state.filteredQuickBookMovies,
  getQuickBookCinemas: state => state.quickBookCinemas,
  getQuickBookDates: state => state.quickBookDates,
  getQuickBookTimes: state => state.quickBookTimes,
  getFilteredQuickBookCinemas: state => state.filteredQuickBookCinemas,
  getSelectedQBMovie: state => state.selectedQBMovie,
  getSelectedQBCinema: state => state.selectedQBCinema,
  getSelectedQBDate: state => state.selectedQBDate,
  getSelectedQBTime: state => state.selectedQBTime,
  getUserReviews: state => state.user_reviews,
  getStripePublisherKey: state => state.stripePublisherKey,
  getAllCinemasList: state => state.CinemasList,
  getSelectedCinema: state => state.selectedCinema,
  getCurrCode: state => state.curr_code,
  getCountries: state => state.countries,
  getGlobalOptions: state => state.global_options
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/MainStore.js